import { Component, OnInit } from '@angular/core';
import { environment } from 'environments/environment.prod';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  version:string = environment.sysVersionName;
  copyright:string = environment.coppyright;
  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/footer/footer.component.ts